module.exports = __webpack_public_path__ + "static/img/099.38a7c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/099.png
// module id = klyB
// module chunks = 0